import logo from './logo.svg';
import './App.css';
import UnityContainer from './components/UnityContainer';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import RegisterPage from './components/auth/RegisterPage';
import { AuthProvider } from './contexts/AuthContext';
import AdminDashboard from './components/admin/AdminDashboard';

function App() {
  // return (
  //   <div className="App">
  //     <header className="App-header">
  //       <img src={logo} className="App-logo" alt="logo" />
  //       <p>
  //         Edit <code>src/App.js</code> and save to reload.
  //       </p>
  //       <a
  //         className="App-link"
  //         href="https://reactjs.org"
  //         target="_blank"
  //         rel="noopener noreferrer"
  //       >
  //         Learn React
  //       </a>
  //       <UnityContainer />
  //     </header>
  //   </div>
  // );
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/explore" element={
            <UnityContainer
              loaderUrl="unity/patmeta/PatMeta.loader.js"
              dataUrl="unity/patmeta/PatMeta.data"
              frameworkUrl="unity/patmeta/PatMeta.framework.js"
              codeUrl="unity/patmeta/PatMeta.wasm"
            /> 
          }/>
          <Route path="/register" element={
            <RegisterPage />
          } />
          <Route path="/admin" element={
            <AdminDashboard />
          } />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
